import type { CourseLightModel, CourseModel, SessionLightModel, SessionModel } from "@24hbs/utils";
import { useCourseTypeUtils } from "./courses/type-utils";
import type { ICourseTypeFields } from "./contentful/types";

const coursesStaticData = {
    CZ24000700: {
        note: "Digital Marketing",
        competenzeShort: "Iscriviti al primo <strong>Corso di Laurea in Scienze della Comunicazione e Media Digitali – Piano di studi Digital Marketing</strong>, che si rivolge <strong>a coloro che desiderano intraprendere un percorso di studi universitario</strong> nel marketing e nella comunicazione digitale, con l’approccio, la metodologia e l’esperienza di una Business School.<br />Il Corso di Laurea è finalizzato a fornire tutti gli strumenti più aggiornati per l’analisi del <strong>comportamento del consumatore</strong> e per trasferire tutte le strategie più evolute <strong>di digital marketing e social media strategy.</strong>",
        lessonModel: {
            quandoIniziare: "Le iscrizioni al Corso di Laurea sono <strong>sempre aperte</strong>. L'inizio del Corso di Laurea avviene al momento di ogni singola iscrizione.<br /><br />Gli insegnamenti del Corso di Laurea si svolgono in <strong>modalità On demand</strong>, fermo restando lo <strong>svolgimento in presenza degli esami di profitto e della discussione delle prove finali</strong> e di eventuali attività di tirocinio curriculare o extracurriculare.<br /><br />Sono previste alcune sessioni in Live Streaming dedicati a laboratori e approfondimenti che permettono l’interazione con i docenti e i colleghi.<br /><br />Il Corso di Studio prevede un <strong>alto grado di indipendenza del percorso didattico da vincoli di presenza fisica o di orario specifico</strong> e il monitoraggio continuo del livello di apprendimento, attraverso il tracciamento del percorso e attraverso <strong>frequenti momenti di valutazione e autovalutazione</strong>.",
            tasseUniversitarie: "La tassa di iscrizione annuale è di 5.000 €. La quota è <strong>rateizzabile fino a 12 rate</strong>."
        },
        modules: {
            title: "PIANO DI STUDI - ORIENTAMENTO AL DIGITAL MARKETING",
            modules: [
                {
                    title: "I Anno",
                    modules: [
                        {
                            subtitle: "CFU 6",
                            title: "Teoria e Filosofia dei Linguaggi dei media e dello spettacolo",
                        },
                        {
                            subtitle: "CFU 6",
                            title: "Teoria e tecniche della comunicazione di massa",
                        },
                        {
                            subtitle: "CFU 12",
                            title: "Storia Contemporanea",
                        },
                        {
                            subtitle: "CFU 6",
                            title: "Internet e Social Media Studies",
                        },
                        {
                            subtitle: "CFU 12",
                            title: "Estetica della Comunicazione",
                        },
                        {
                            subtitle: "CFU 12",
                            title: "Informatica per la comunicazione digitale",
                        },
                        {
                            subtitle: "CFU 6",
                            title: "Laboratorio: Orientamento alle professioni digitali",
                        }
                    ]
                },
                {
                    title: "II Anno",
                    modules: [
                        {
                            subtitle: "CFU 6",
                            title: "Metodologia della Ricerca sociale e analisi dei consumi",
                        },
                        {
                            subtitle: "CFU 6",
                            title: "Psicologia Sociale",
                        },
                        {
                            subtitle: "CFU 12",
                            title: "Linguaggi e tecniche dell’informazione pubblica: radio, Tv e testate online",
                        },
                        {
                            subtitle: "CFU 6",
                            title: "Comunicazione Pubblica e Istituzionale",
                        },
                        {
                            subtitle: "CFU 12",
                            title: "Fondamenti di Marketing",
                        },
                        {
                            subtitle: "CFU 12",
                            title: "Digital Marketing",
                        },
                        {
                            subtitle: "CFU 6",
                            title: "Tecnologie multimediali per il cinema e la televisione",
                        },
                        {
                            subtitle: "CFU 6",
                            title: "Idoneità lingua inglese B1",
                        },
                        {
                            subtitle: "CFU 6",
                            title: "Laboratorio: Data Driven Marketing",
                        }
                    ]
                },
                {
                    title: "III Anno",
                    modules: [
                        {
                            subtitle: "CFU 6",
                            title: "Istituzioni di diritto pubblico<br /><br /><div class=\"w-full text-center !text-gray-300\">oppure</span><br /><br />Diritto dell’informazione dell’accesso e delle telecomunicazioni",
                        },
                        {
                            subtitle: "CFU 6",
                            title: "Educazione ai Media",
                        },
                        {
                            subtitle: "CFU 6",
                            title: "Etica della Comunicazione",
                        },
                        {
                            subtitle: "CFU 6",
                            title: "Content Strategy & Digital Storytelling",
                        },
                        {
                            subtitle: "CFU 6",
                            title: "Social Media Marketing",
                        },
                        {
                            subtitle: "CFU 6 + 6",
                            title: "Esami a scelta libera",
                        },
                        {
                            subtitle: "CFU 6",
                            title: "Laboratorio: Search advertising",
                        },
                        {
                            subtitle: "CFU 6",
                            title: "Idoneità linguistiche: francese, spagnolo, tedesco B1",
                        },
                        {
                            subtitle: "CFU 6",
                            title: "Tesi di laurea",
                        }
                    ]
                }
            ],
        },
        chiDiventerai: {
            text: "Il Corso prepara laureati in grado di operare nei diversi settori del marketing digitale e della comunicazione in ambito pubblico e privato presso istituzioni, associazioni, enti, aziende, editori, testate giornalistiche, agenzie creative di comunicazione e di organizzazione di eventi culturali, centri media, concessionarie pubblicitarie.<br /><br /><strong>Lo stage curriculare diventa un volano importante per inserirsi nel mondo del lavoro e permette sin da subito di avere una prima esperienza di valore.</strong>",
            professionalOutlets: [
                {
                image: "/assets/images/corso-di-laurea-digital-marketing/digital_marketer.png",
                title: "Digital Marketer",
                text: "Un professionista in grado di progettare un piano di comunicazione digitale per acquisire e mantenere clienti nel panorama pubblicitario digitale."
                },
                {
                image: "/assets/images/corso-di-laurea-digital-marketing/content_creator.png",
                title: "Content Creator",
                text: "Un professionista che crea contenuti utili e di valore, supervisionando tutta la comunicazione visiva, emozionale e testuale di un brand."
                },
                {
                image: "/assets/images/corso-di-laurea-digital-marketing/social_media_manager.png",
                title: "Social Media Expert",
                text: "Un professionista che crea e gestisce la strategia della comunicazione di una o più pagine aziendali dei maggiori social network, per condividere contenuti di interesse per i follower e spingerli a interagire, cercando di instaurare un dialogo con loro."
                },
                {
                image: "/assets/images/corso-di-laurea-digital-marketing/digital_strategist.png",
                title: "Digital Strategist",
                text: "Un professionista in grado di massimizzare la presenza online di brand attraverso l'utilizzo dei migliori canali digitali e con le diverse tipologie di contenuto."
                }
            ]
        },
        certificates: [
            {
                image: "/assets/images/corso-di-laurea-digital-marketing/alwayson.png",
                title: "Always On",
                text: "<strong>Always On</strong><br />Didattica flessibile, On demand + Live Streaming"
            },
            {
                image: "/assets/images/corso-di-laurea-digital-marketing/company_visits.png",
                title: "Company Visit",
                text: "Company Visit e Laboratori per ogni anno accademico"
            },
            {
                image: "/assets/images/corso-di-laurea-digital-marketing/partecipazione_master_24orebs.png",
                title: "Partecipazione Master 24Ore Business School",
                text: "<strong>Partecipazione</strong> a una sessione <strong>in presenza</strong> al Master Marketing Comunicazione e Digital Strategy di 24Ore Business School a Roma o Milano"
            },
            {
                image: "/assets/images/corso-di-laurea-digital-marketing/prima_edizione.png",
                title: "Prima edizione",
                text: "Il primo Corso di Laurea progettato da <strong>24ORE Business School</strong> e <strong>Unimarconi</strong>"
            },
            {
                image: "/assets/images/corso-di-laurea-digital-marketing/stage_curriculari.png",
                title: "Stage curriculari",
                text: "<strong>Stage curriculari</strong> in azienda"
            },
            {
                image: "/assets/images/corso-di-laurea-digital-marketing/docenti_estrazione_aziendale.png",
                title: "Docenti di estrazione aziendale",
                text: "<strong>100%</strong><br />Docenti e consulenti di estrazione aziendale di 24ORE Business School e docenti di Università degli Studi Guglielmo Marconi"
            },
            {
                image: "/assets/images/corso-di-laurea-digital-marketing/laboratori_orientamento.png",
                title: "Laboratori di Orientamento",
                text: "<strong>Laboratori di Orientamento</strong> alle professioni digitali"
            },
            {
                image: "/assets/images/corso-di-laurea-digital-marketing/network.png",
                title: "Network",
                text: "<strong>Il Network</strong> di studenti e docenti di 24ORE Business School e Università degli Studi Guglielmo Marconi"
            }
        ],
        infos: [
            {
                title: "IMMATRICOLAZIONE",
                text: "<p>È necessario accedere al sito dell’Università Guglielmo Marconi, dovrai registrarti alla sezione My Unimarconi e seguire il processo di immatricolazione al Corso di Laurea in Digital Marketing.</p>"
            },
            {
                title: "ESAMI",
                text: "<p>Gli esami di profitto consistono in prove orali e/o scritte che si svolgono in presenza.<br />La verifica del profitto utile per l’acquisizione dei crediti è compiuta per ogni corso e attività formativa secondo le modalità e i criteri stabiliti dal titolare dell’insegnamento. A tal fine potranno essere previsti esami (orali e/o scritti) e prove di verifica (tesine, colloqui, ecc.) durante tutto lo svolgimento del corso. Le commissioni di esame, di almeno due membri, sono presiedute dal titolare dell’insegnamento. Le commissioni potranno anche articolarsi in sottocommissioni a loro volta composte da almeno due membri.<br /><br />Le valutazioni saranno effettuate sotto la responsabilità del titolare dell’insegnamento e i risultati verranno attestati con le firme dei componenti. La valutazione sarà espressa in trentesimi, con eventuale lode. Il voto minimo per il superamento dell’esame è di diciotto trentesimi.<br /><br />Per essere ammessi a sostenere gli esami occorre essere in regola con la posizione amministrativa.</p>"
            },
            {
                title: "ESAME DI LAUREA",
                text: "<p>Il Corso di Laurea si conclude con una prova finale che consiste nella discussione di un elaborato originale preparato dallo studente.<br /><br />Il voto di ammissione all’esame finale è costituito dalla media ponderata dei voti conseguiti nei singoli insegnamenti.<br /><br />Il voto finale di laurea è determinato dalla media ponderata dei voti a cui si aggiunge il punteggio assegnato dalla Commissione di laurea entro il limite massimo di 9 punti.<br /><br />Potrà richiedere la tesi di laurea lo studente che:<br /></p><ul><li>risulti iscritto all’ultimo anno di corso;</li><li> debba sostenere non più di  4 esami, comprese le idoneità, le ulteriori attività formative e il tirocinio;</li><li>presenti la richiesta di assegnazione tesi di laurea (Modulo L1) entro le seguenti scadenze:<ul style=\"list-style: circle\"><li>Sessione Invernale (Marzo/Aprile) – entro e non oltre il 15/07</li><li>Sessione Estiva (Giugno/Luglio) – entro e non oltre il 15/10</li><li>Sessione Autunnale (Novembre/Dicembre) – entro e non oltre il 31/03</li></ul></li></ul>"
            },
            {
                title: "PAGAMENTO",
                text: "<p>La tassa di iscrizione annuale è di € 5.000 euro e la quota è rateizzabile fino a 12 rate.<br /><br />Il pagamento in un'unica soluzione o rateizzato, può essere effettuato, tramite banca, usando le seguenti coordinate:<br /><br />Destinatario: Università degli Studi “Guglielmo Marconi” BANCO BPM S.P.A.<br />IBAN: IT 87 M 05034 03204 000000003156<br />SWIFT CODE: BAPPIT21A64<br /><br />Oppure tramite posta, usando questi estremi:<br /><br />versamento a Università degli Studi “Guglielmo Marconi”, su C/C  postale n° 000041050170<br />con IBAN: IT 32 S 07601 03200 000041050170 e SWIFT CODE: BPPIITRRXXX<br /><br />É sempre necessario inserire la causale di versamento con le seguenti impostazioni:</p><ul class=\"list-disc\"><li>Per chi deve immatricolarsi: nome e cognome dello studente + sigla del corso scelto (segnalato sul sito Unimarconi)</li><li>Per gli studenti già iscritti: matricola (obbligatoria) + specifica di quello che si sta pagando</li></ul>"
            }
        ]
    }
}


const FAQ = [
    {
        question: "È prevista un test di ammissione per accedere al Corso di Laurea? ",
        answer: "Il Corso è ad accesso libero, senza test di ammissione"
    },
    {
        question: "Sono previsti stage/tirocini curriculari?",
        answer: "I tirocini curriculari sono tirocini previsti nei Piano di Studi, si attivano all’ultimo anno di corso di laurea ed al raggiungimento di 120 CFU per le triennali."
    },
    {
        question: "È possibile l'iscrizione anche da parte di studenti stranieri?",
        answer: "Sì, consultare la pagina dedicata “Studenti stranieri e titoli esteri” sul sito dell'Università G. Marconi"
    },
    {
        question: "Quali sono le rateazioni e i termini di pagamento?",
        answer: "È previsto rateizzare fino ad un massimo di 12 rate. Non sono previste agevolazioni o promozioni"
    },
    {
        question: "Le certificazioni di lingua possono valere come CFU?",
        answer: "Sì, previa valutazione puntuale della certificazione"
    },
    {
        question: "La domanda può essere presentata sia online che cartacea?",
        answer: "Sì, attraverso la pagina online e il modulo apposito"
    },
    {
        question: "Il titolo è riconosciuto?",
        answer: "Si, l'università degli studi Guglielmo Marconi è stata la prima università telematica italiana riconosciuta dal MIUR con D.M. 1° marzo 2004"
    },
    {
        question: "Quando è possibile iscriversi?",
        answer: "Le iscrizioni sono sempre aperte. L'iscrizione parte dal momento dell'immatricolazione e dura esattamente 365 giorni"
    }
];

function isCourseOfTypeLaurea(course: CourseModel | CourseLightModel | SessionLightModel | SessionModel, fetchFn: {
    (input: RequestInfo | URL, init?: RequestInit): Promise<Response>;
    (input: string | URL | globalThis.Request, init?: RequestInit): Promise<Response>;
}): boolean {
    if (!course || !course.courseTypeFull) return false;
    const courseTypeUtils = useCourseTypeUtils(fetchFn);
    
    courseTypeUtils
        .getCourseTypeByName(course.courseTypeFull)
        .then((courseType: ICourseTypeFields | null) => {
            if (courseType && courseType.slug === 'corsi-laurea') {
                return true;
            }
            return false;
        })
        .catch(() => {
            console.warn("Error fetching course type data");
            return false;
        })
    return false;
}

export const LaureaUtils = {
    coursesStaticData,
    FAQ,
    isCourseOfTypeLaurea
}